import React, { useState } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { Tab } from './Tab/Tab';
import get from 'lodash/get';

const Social = loadable(() => import('../../social/social'));

const ShareBubbles = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="https://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.36328 12.4576C2.80265 12.4577 2.26505 12.2352 1.8684 11.8389C1.47189 11.4428 1.24901 10.9052 1.24887 10.3447C1.24872 9.78417 1.47116 9.24652 1.86736 8.85007C2.26358 8.45363 2.80117 8.23065 3.36181 8.23039C3.92229 8.2301 4.46018 8.4525 4.85669 8.84864C5.25335 9.24478 5.47633 9.78214 5.47678 10.3427C5.47663 10.9032 5.25391 11.4407 4.85769 11.8373C4.46133 12.2339 3.92388 12.4569 3.36324 12.4576H3.36328ZM16.6141 14.854C17.1748 14.854 17.7124 15.0767 18.1087 15.473C18.5052 15.8692 18.728 16.4067 18.7281 16.9672C18.7283 17.5276 18.5057 18.0653 18.1095 18.4617C17.7131 18.8581 17.1757 19.081 16.615 19.0812C16.0545 19.0814 15.5168 18.859 15.1201 18.463C14.7236 18.0669 14.5006 17.5295 14.5002 16.969C14.5003 16.4083 14.7231 15.8706 15.1194 15.4741C15.5158 15.0776 16.0534 14.8545 16.6142 14.8541L16.6141 14.854ZM16.6141 1.60688C17.1749 1.60688 17.7127 1.82972 18.1091 2.22616C18.5055 2.62261 18.7282 3.16026 18.7281 3.72091C18.7279 4.2816 18.5051 4.81925 18.1084 5.21555C17.7118 5.61184 17.174 5.83438 16.6133 5.83409C16.0525 5.8338 15.5149 5.61082 15.1185 5.21426C14.7223 4.81767 14.4999 4.27975 14.5002 3.71921C14.5009 3.15897 14.7238 2.62191 15.1201 2.22591C15.5165 1.82991 16.0538 1.60718 16.6141 1.60688ZM16.6141 7.07961C17.56 7.07975 18.4623 6.68158 19.0996 5.98271C19.7369 5.28383 20.0504 4.34889 19.963 3.40716C19.8757 2.46529 19.3957 1.6039 18.6409 1.03415C17.8859 0.464249 16.9259 0.238685 15.9961 0.412584C15.0663 0.58662 14.2527 1.144 13.755 1.94823C13.2573 2.75247 13.1214 3.72916 13.3805 4.63879L6.03822 8.30877C5.46649 7.55734 4.60511 7.0809 3.66455 6.99611C2.72411 6.91118 1.79133 7.22571 1.09421 7.86254C0.397098 8.49951 0 9.40007 0 10.3442C0 11.2884 0.397061 12.1889 1.09421 12.8259C1.79133 13.4627 2.72414 13.7773 3.66455 13.6924C4.60514 13.6076 5.46653 13.1311 6.03822 12.3797L13.3805 16.0497C13.0685 17.1371 13.3221 18.3084 14.0559 19.1695C14.7899 20.0304 15.9064 20.4664 17.0297 20.3309C18.153 20.1951 19.1335 19.5057 19.6412 18.4948C20.1488 17.4838 20.1161 16.2858 19.5539 15.304C18.9918 14.3223 17.9751 13.6873 16.8461 13.6132C15.7172 13.5391 14.626 14.0354 13.9403 14.9351L6.59649 11.2625C6.7681 10.6624 6.7681 10.0261 6.59649 9.42602L13.9403 5.75346C14.5752 6.58909 15.5644 7.07994 16.6141 7.07994L16.6141 7.07961Z"
      fill="white"
    />
  </svg>
);

export const Tabs = props => {
  const [stickyBarSocialOpen, setStickyBarSocialOpen] = useState(false);
  const { showShareTabIcon, shareUri } = props;

  return (
    <div className="tabs">
      {props.data.map((tab, i) => (
        <Tab
          key={`tab-${i}`}
          category={tab.category}
          image={tab.image}
          tabIndex={i}
          {...props}
        />
      ))}
      {showShareTabIcon && (
        <>
          <div
            className={`tab tab-share${stickyBarSocialOpen ? ' show' : ''}`}
            onClick={() => setStickyBarSocialOpen(!stickyBarSocialOpen)}
          >
            <ShareBubbles width={20} color="#ED0F69" />
          </div>

          {stickyBarSocialOpen && (
            <div className="social-box">
              <Social
                modifier="StickyBar"
                disableStyle={true}
                hideRecirc={true}
                uri={shareUri}
                horizontal
                text={get(props, 'post.title', '')}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

Tabs.propTypes = {
  data: PropTypes.shape([]).isRequired,
  showShareTabIcon: PropTypes.bool,
  shareUri: PropTypes.string
};

Tabs.defaultProps = {
  showShareTabIcon: false,
  shareUri: ''
};
